module.exports = __webpack_public_path__ + "img/template-2-mobile.0e32b55f.png";